import axios from 'axios'

import { noPaginationParams } from '../constants'

const commonServices = {
  getViews: ({ storeId, type }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/views`, { params: { type } }),
  createView: ({ storeId, name, filters, type, sharedWithGroups }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/views`, {
      name,
      filters,
      type,
      shared_with_groups: sharedWithGroups,
    }),
  deleteView: ({ storeId, viewId }) => axios.delete(`${import.meta.env.VITE_HOST}/stores/${storeId}/views/${viewId}`),
  saveView: ({ storeId, viewId, name, filters, sharedWithGroups }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/views/${viewId}`, {
      name,
      filters,
      shared_with_groups: sharedWithGroups,
    }),
  getMerchantViews: ({ merchantId, type }) =>
    axios.get(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/views`, { params: { type } }),
  createMerchantView: ({ merchantId, name, filters, type, sharedWithGroups }) =>
    axios.post(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/views`, {
      name,
      filters,
      type,
      shared_with_groups: sharedWithGroups,
    }),
  deleteMerchantView: ({ merchantId, viewId }) =>
    axios.delete(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/views/${viewId}`),
  saveMerchantView: ({ merchantId, viewId, name, filters, type, sharedWithGroups }) =>
    axios.put(`${import.meta.env.VITE_HOST}/merchant/${merchantId}/views/${viewId}`, {
      name,
      filters,
      type,
      shared_with_groups: sharedWithGroups,
    }),
  getRegions: () => axios.get(`${import.meta.env.VITE_HOST}/regions`, { params: { ...noPaginationParams } }),
  getUserPreferences: ({ storeId, userId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/users/${userId}/preferences`),
  getShopInfo: () => axios.get(`${import.meta.env.VITE_HOST}/merchant/`),
  getUserProfile: () => axios.get(`${import.meta.env.VITE_HOST}/me`),
  getCurrencies: () => axios.get(`${import.meta.env.VITE_HOST}/currencies`),
  getMetrics: ({ returnPortalId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/metrics`, { params: { portal_id: returnPortalId } }),
  getStoreNotifications: ({ params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/notifications`, { params: { ...params } }),
  markNotificationAsRead: ({ notificationId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/notifications/${notificationId}/mark-as-read`),
  markAllNotificationsAsRead: () => axios.post(`${import.meta.env.VITE_HOST}/notifications/mark-as-read`),
  getSystemAlerts: () => axios.get(`${import.meta.env.VITE_HOST}/system-alerts`),
  getCarrierServices: ({ storeId, type, section, sourceRegion, destinationRegion }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/preferences/carrier-services`, {
      params: { type, section, source_region: sourceRegion, destination_region: destinationRegion },
      paramsSerializer: { indexes: null },
    }),
  getStoreProductCategories: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/categories`, { params: { enabled: true, store_id: storeId } }),
  getStoreProductCollections: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/collections`, {
      params: { enabled: true, store_id: storeId },
    }),
  getWayFlyerToken: () => axios.post(`${import.meta.env.VITE_HOST}/wayflyer/token`),
  setWayFlyerProcessAsInitialized: () => axios.post(`${import.meta.env.VITE_HOST}/wayflyer/initialize`),
  getCarriers: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/carriers`, { params: { store_id: storeId } }),
  getInventoryLocations: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-locations`, {
      params: { ...noPaginationParams },
    }),
  getMerchantInventoryLocations: () => axios.get(`${import.meta.env.VITE_HOST}/merchant/inventory-locations`),
  goLive: () => axios.post(`${import.meta.env.VITE_HOST}/merchant/go-live`),
  getHistory: ({ returnPortalId, fieldKeys, fieldKeyPrefix, cursor, objectId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/portals/${returnPortalId}/settings-history`, {
      params: { field_keys: fieldKeys, field_key_prefix: fieldKeyPrefix, cursor, object_id: objectId },
    }),
  getRuleFeatures: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/rules/features`),
}

export default commonServices
